import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { ShellComponent } from './components/shell/shell.component';
import { FilterComponent } from './components/partials/filter/filter.component';
import { HeaderComponent } from './components/partials/header/header.component';
import { SharedModule } from '../shared/shared.module';
import { RouterModule, Routes } from '@angular/router';
import { NotFoundComponent } from './components/errors/notfound/notfound.component';
import { TabsComponent } from './components/tabs/tabs.component';
import { UnauthorizedComponent } from './components/errors/unauthorized/unauthorized.component';
import { InternalServerErrorComponent } from './components/errors/internal-server-error/internal-server-error.component';
import { LogoutModalComponent } from './components/modals/logout-modal/logout-modal.component';
import { FooterComponent } from './components/partials/footer/footer.component';
import { ReportsComponent } from './components/reports/reports.component';
// import { SIDComponent } from './components/sid/sid.component';
import { ReportFilterComponent } from './components/partials/report-filter/report-filter.component';
import { ConfirmationModalComponent } from './components/modals/confirmation-modal/confirmation-modal.component';
import { MarginCalculatorListComponent } from '../margin-calculator/components/list/list.component';
import { MarginAppFilterComponent } from '../margin-calculator/components/filter/filter.component';
import { MarginCalculatorViewComponent } from '../margin-calculator/components/view/view.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GridDataComponent } from '../margin-calculator/components/grid-data/grid-data.component';
import { SaveModalComponent } from '../margin-calculator/components/save-modal/save-modal.component';
import { HelpComponent } from './components/help/help.component';
import { MarginCostUploadFilterComponent } from '../margin-cost-upload/components/filter/filter.component';
import { MarginCostUploadListComponent } from '../margin-cost-upload/components/list/list.component';
import { MarginCostUploadViewComponent } from '../margin-cost-upload/components/view/view.component';
import { DefaultCostUploadComponent } from '../margin-cost-upload/default-cost-upload/default-cost-upload.component';
import { ProjectBainTargetsUploadComponent } from '../margin-cost-upload/project-bain-targets-upload/project-bain-targets-upload.component';
import { PracticeAreaUploadComponent } from '../margin-cost-upload/practice-area-upload/practice-area-upload.component';
import { BainTargetsUploadComponent } from '../margin-cost-upload/bain-targets-upload/bain-targets-upload.component';

@NgModule({
  declarations: [
    ShellComponent,
    FilterComponent,
    HeaderComponent,
    NotFoundComponent,
    TabsComponent,
    UnauthorizedComponent,
    InternalServerErrorComponent,
    LogoutModalComponent,
    FooterComponent,
    ReportsComponent,
    // SIDComponent,
    ReportFilterComponent,
    ConfirmationModalComponent,
    MarginCalculatorListComponent,
    MarginAppFilterComponent,
    MarginCalculatorViewComponent,
    GridDataComponent,
    SaveModalComponent,
    HelpComponent,
    MarginCostUploadListComponent,
    MarginCostUploadFilterComponent,
    MarginCostUploadViewComponent,
    DefaultCostUploadComponent,
    ProjectBainTargetsUploadComponent,
    PracticeAreaUploadComponent,
    BainTargetsUploadComponent
  ],
  imports: [
    FormsModule,
    CommonModule,
    HttpClientModule,
    RouterModule,
    SharedModule,
    ReactiveFormsModule
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})

export class GlobalModule { }
